import React, {useState} from 'react';

import {ImagePreview} from 'app/general/uploader/components/ImagePreview';
import {useAttachmentsUploader} from 'app/general/uploader/hooks';
import {useAccountSettingsState} from 'app/settings/api';
import {getMediaPath, removeMediaPath} from 'app/utils/fineuploader';

import {ImageAttachmentsUploader} from '../uploader/components/ImageAttachmentsUploader';

import {BaseAttachedImage} from 'sweet-types';

interface Props {
  initialThumbnail: string | null;
  onUpdateThumbnail: (thumbnail: string) => void;
}

export function DocumentThumbnail({
  initialThumbnail,
  onUpdateThumbnail,
}: Props) {
  const {uploaderRef, setSubmittedImages, removeAttachment} =
    useAttachmentsUploader();
  const settings = useAccountSettingsState().data!;

  const [thumbnail, setThumbnail] = useState<string>(initialThumbnail ?? '');

  function addThumbnail(image: BaseAttachedImage) {
    const imageURL = removeMediaPath(image.image_ref, settings.MEDIA_URL);
    setThumbnail(imageURL);
    onUpdateThumbnail(imageURL);
  }

  function removeThumbnail(thumbnail: string) {
    setThumbnail('');
    onUpdateThumbnail('');
    const mediaPath = getMediaPath(settings.MEDIA_URL);
    const key = removeMediaPath(thumbnail, settings.MEDIA_URL);
    removeAttachment(mediaPath + key);
  }

  return (
    <div className="mr-1 mb-1">
      {thumbnail === '' ? (
        <ImageAttachmentsUploader
          inputLabel=""
          iconSizeClass="fa-5x"
          uploaderRef={uploaderRef}
          onAddImage={addThumbnail}
          setSubmittedImages={setSubmittedImages}
        />
      ) : (
        <ImagePreview
          attachment={{image_ref: thumbnail}}
          onRemoveAttachment={removeThumbnail}
          spinnerSizeClass="spinner-border-sm"
        />
      )}
    </div>
  );
}
